<template>
  <div class = "mainpage">
    <h1>About This Website</h1>
    <p>The website owner refers to himself as an IT Swordman, and he is from mainland China. He self-taught Japanese before coming to Japan for work, where he began learning Kendo. Since Japanese is not his native language, he encountered many challenges, but through self-research and guidance from his teacher, he gradually learned various vocabulary. The main purpose of this website is to help non-native Japanese speakers learn Japanese related to Kendo. The owner is still learning and welcomes any advice and support. </p>

    <h2>このサイトについて</h2>
    <p>管理者はIT剣士と名乗り、中国から来ました。独学で日本語を学び、日本で仕事を始めると同時に剣道を始めました。日本語は母国語ではないため、いくつかの障害に直面しましたが、自分で資料を調べ、先生から教わりながら、少しずつ語彙を覚えました。このウェブサイトは、主に日本語を母国語としない方々が剣道に関連する日本語を学ぶために作られました。管理者自身も引き続き学んでいるので、ぜひアドバイスとサポートをいただければと思います。</p>

    <h2>关于本站</h2>
    <p>站长自称为IT剑士，来自中国大陆。自学日语来到了日本工作，在日本工作期间开始了剑道的学习。由于日语不是自己的母语，所以遇到很多障碍，在自己查资料以及老师的教导下，慢慢记住了一些词汇。本网站的主要目的是帮助非日语母语者学习剑道相关的日语。站长也在不断学习中，欢迎各位给予指导与支持。</p>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainpage {
    text-align: left;
    width: 99%;
    display: flex;
    flex-direction: column; /* 子元素竖直排列 */
    align-items: flex-start; /* 左对齐 */
}

</style>
